import { Component } from '@angular/core';
import { removeCaracter } from 'src/app/core/constants/properties-const';

@Component({
  selector: 'app-other-infos',
  templateUrl: './other-infos.component.html',
  styleUrls: ['./other-infos.component.scss']
})
export class OtherInfosComponent {

  public removeCaracter = removeCaracter;
  dropdownOptions = [
    {name: 'mock 01' },
    {name: 'mock 02' },
    {name: 'mock 03' },
  ];


}